import React from 'react'

import { Form, Col } from '_zari/core'

const ImporteFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='number-importe' md={4} />
      <Col md={8}>
        <Form.InputNumber id='number-importe' disabled defaultValue={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
